import { Update } from "../components/gw-register/Update";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
GW事業者更新情報登録画面
 */
const GwBusinessInfoUpdate = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.GW);
  return (
    <SpaceBetween size="l">
      <Update />
    </SpaceBetween>
  );
};

export default GwBusinessInfoUpdate;
